import { useState, useCallback } from 'react';
import { liveTrackingService, LiveTrackingState, LiveTrackingCallbacks } from '../service/liveTracking.service';

export const useLiveTracking = () => {
    const [state, setState] = useState<LiveTrackingState>(liveTrackingService.getInitialState());

    const startTracking = useCallback(async (vehicleRegNo: string) => {
        if (!vehicleRegNo) {
            console.error('❌ Vehicle registration number is required');
            return false;
        }

        // Set loading state
        setState(prev => ({ ...prev, ...liveTrackingService.getLoadingState() }));

        const callbacks: LiveTrackingCallbacks = {
            onFirstDataReceived: () => {
                setState(prev => ({ ...prev, ...liveTrackingService.getDataReceivedState() }));
            },
            onError: (error: string) => {
                setState(prev => ({ ...prev, ...liveTrackingService.getErrorState(error) }));
            },
            onLoadingChange: (isLoading: boolean) => {
                setState(prev => ({ ...prev, isLoading }));
            }
        };

        const success = await liveTrackingService.startLiveTracking(vehicleRegNo, callbacks);

        if (success) {
            setState(prev => ({ ...prev, ...liveTrackingService.getTrackingStartedState() }));
        }

        return success;
    }, []);

    const resetTracking = useCallback(() => {
        setState(liveTrackingService.getInitialState());
    }, []);

    const setFirstDataReceived = useCallback(() => {
        setState(prev => ({ ...prev, ...liveTrackingService.getDataReceivedState() }));
    }, []);

    return {
        // State
        showMap: state.showMap,
        hasTrackingData: state.hasTrackingData,
        isLoading: state.isLoading,
        error: state.error,

        // Actions
        startTracking,
        resetTracking,
        setFirstDataReceived,

        // Computed
        canShowMap: state.showMap && state.hasTrackingData,
        isInLoadingState: state.showMap && !state.hasTrackingData && !state.isLoading
    };
};

